import { baseUrl } from './api.js';

/**
 * Krok AS3 bod 5 — plocha „Asistentka“. Prohlizec mluvi JEN s adminim
 * backendem (`/api/admin/asistentka/*`, proxy pod admin middleware); core
 * na serveru 138 ani jeho token nikdy nevidi.
 *
 * Tvar odpovedi core: `integrations/asistentka/ADMIN-SURFACE-CONTRACT.md`.
 */

export interface AsistentkaFinding {
  readonly code: string;
  readonly key: string;
  readonly severity: 'high' | 'medium' | 'low';
  readonly title: string;
  readonly why: string;
  readonly fix: string;
  readonly bucket: string;
  readonly owner: string;
  readonly urgency: 'today' | 'week' | 'later';
  readonly waitingFor: 'klient' | 'zajemce' | null;
  readonly link: string | null;
}

export interface AsistentkaBriefing {
  readonly day: string;
  readonly text: string;
  readonly createdAt: string;
}

export type CoreResult<T> = { readonly connected: true; readonly data: T } | { readonly connected: false };

async function core<T>(path: string): Promise<CoreResult<T>> {
  let res: Response;
  try {
    res = await fetch(`${baseUrl}/api/admin/asistentka/${path}`, { credentials: 'include' });
  } catch {
    return { connected: false };
  }
  // 503 NOT_CONNECTED (core nedostupne / connection neni) i jina chyba core =
  // „Asistentka zatím není připojená“ — plocha nema byt chybova obrazovka.
  if (!res.ok) return { connected: false };
  return { connected: true, data: (await res.json()) as T };
}

export function getAsistentkaBriefing(): Promise<CoreResult<AsistentkaBriefing | null>> {
  return core<AsistentkaBriefing | null>('v1/briefing');
}

export function getAsistentkaChecks(): Promise<CoreResult<{ readonly findings: readonly AsistentkaFinding[]; readonly checkedAt: string | null }>> {
  return core('v1/checks');
}
